import React, { useState } from 'react'
import { Card, CardContent, Typography, Grid, Button, Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import Modal from './Modal';
import { HomeSkeleton } from './HomeSkeleton';
import { Stack } from '@mui/system';

export const CardUI = ({ ejes }) => {
    const [open, setOpen] = useState(false);
    const [ejeDialog, setTemaDialog] = useState(null);
    const { t } = useTranslation();

    const handleClickOpen = (temaDialog) => {
        setTemaDialog(temaDialog);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box>
            <Grid container
                spacing={2}
            >
                {ejes ? (
                    ejes.map((eje, index) =>
                        <Grid item xs={12} sm={6} lg={3} key={index}>
                            <Card className='card' onClick={() => { handleClickOpen(eje) }} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px'}}>
                                <CardContent sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '1em', height: '100%'}}>
                                    <Box component="img" src={require("../../images/" + eje.key + ".png")} loading="lazy" alt={eje.key} />
                                    <Typography variant="h5" style={{ fontSize: '1.1em' }}>
                                        {eje.texto}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                    )
                )
                    :
                    (
                        <HomeSkeleton />
                    )}
                {ejeDialog && (
                    <Modal title={ejeDialog.texto} content={ejeDialog.descripcion+"<br><br>"+t("eje.finalDescripcion")} open={open} close={handleClose} >
                        <Button variant="contained" onClick={handleClose} >{t("general.cerrar")}</Button>
                    </Modal>
                )}
            </Grid >
        </Box>
    )
}